import { render, staticRenderFns } from "./ModalNewAttachment.vue?vue&type=template&id=5e24234d"
import script from "./ModalNewAttachment.vue?vue&type=script&lang=js"
export * from "./ModalNewAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports